export type MediaInputIdentity = {
    id?: string | null
    attachmentId?: string | null
    blobId?: string | null
    signedId?: string | null
    uploadId?: string | null
    answerId?: string | null
    runId?: string | null
    actionId?: string | null
}

// Source post/run/action ids describe provenance and can be shared by several distinct files.
// Only file-level identifiers are safe for media selection, deduplication, and removal.
export const mediaInputIdentityValues = (input?: MediaInputIdentity) =>
    [input?.id, input?.attachmentId, input?.blobId, input?.signedId, input?.uploadId]
        .map(value => value?.toString().trim())
        .filter((value): value is string => !!value)

export const haveMatchingMediaIdentity = (
    left?: MediaInputIdentity,
    right?: MediaInputIdentity,
) => {
    const leftValues = mediaInputIdentityValues(left)
    if (!leftValues.length) return false

    const rightValues = new Set(mediaInputIdentityValues(right))
    return leftValues.some(value => rightValues.has(value))
}
